import { FC, forwardRef } from 'react'
import { styled } from '@mui/material/styles'
import classNames from 'classnames'
import { Box } from '@mui/material'

export interface IAttributeProps {
    className?: string
    orientation?: 'horizontal' | 'vertical'
    sx?: object
    children?: React.ReactNode
    'data-ai-explain'?: string
    'data-ai-explain-section'?: string
}
// TODO: Will remove this onc ewe start sending sx instead of classname for all pages

const AttributeWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    padding: '0.224rem 0 0.8rem 0',

    // If an AttributeWrapper is the first-child in it's parent, and it also has a sibling that is also an AttributeWrapper, add this styling
    '&:first-child:has(+ &)': {
        paddingTop: '0.8rem',
    },
}))

export const Attribute: FC<IAttributeProps> = forwardRef((props, ref: any) => {
    const {
        className,
        orientation = 'vertical',
        sx,
        children,
        'data-ai-explain': dataAiExplain,
        'data-ai-explain-section': dataAiExplainSection,
        ...rest
    } = props
    return (
        <AttributeWrapper
            className={classNames(className)}
            ref={ref}
            sx={{
                flexDirection:
                    orientation === 'vertical' ? 'column' : 'row',
                ...(sx && sx),
            }}
            data-ai-explain={dataAiExplain}
            data-ai-explain-section={dataAiExplainSection}
            {...rest}
        >
            {children}
        </AttributeWrapper>
    )
})

Attribute.defaultProps = {
    orientation: 'vertical',
}

export * from './AttributeLabel'
export * from './AttributeValue'
